import { useSyncExternalStore } from "react";

/**
 * Ekran TELEFON genişliğinde mi — kitin kendi kuralının aynısı, ürün tarafında ikinci kez
 * soruluyor. Yuva (tam ekran panel, sıra düzeni) ve sohbet sayfası (liste VEYA konuşma) aynı
 * eşiği bu tek kancadan okuyor; iki ayrı sayı iki ekranı iki farklı genişlikte kırardı.
 *
 * `chat-launcher.css` 768 pikselin altında paneli `inset: 0` ile ekrana yayıyor ve
 * `ChatLauncher` aynı sorguyu `matchMedia` ile okuyup panelin KİPLİĞİNE karar veriyor. Burada
 * sorulan soru başka: liste ile konuşmanın yan yana konup konmayacağı. 375 piksellik bir ekranda
 * yan yana düzen 320'lik bir liste ve 55'lik bir konuşma demek — ikisi de okunmaz, yani dar
 * ekranda yuva sıra düzenine dönmek zorunda.
 *
 * SAYI KİTTEN KOPYA ve kopya olduğu için burada yazılı: kit eşiği değiştirirse bu dosya onunla
 * birlikte değişir. Alternatif panelin kendi genişliğini ölçmekti; `ResizeObserver` bir kare geç
 * geldiği için ilk boyama yanlış şekli çizerdi.
 */
const FULLSCREEN_QUERY = "(max-width: 767px)";

function subscribe(onStoreChange: () => void): () => void {
  const media = window.matchMedia(FULLSCREEN_QUERY);
  media.addEventListener("change", onStoreChange);
  return () => media.removeEventListener("change", onStoreChange);
}

/** Render sırasında okunuyor, bir etkide değil: ilk boyama zaten doğru şekil olsun. */
export function useNarrowScreen(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(FULLSCREEN_QUERY).matches,
    () => false,
  );
}
